import {DataLayerModel} from "@merchant-webapp/components";
import {LocationSectionEnum} from "../../../stations/enums/location-section.enum";

export class AddLocationTimeSpentDataLayerModel extends DataLayerModel {
	public static readonly EVENT_NAME: string = "ADD_LOCATION_TIME_SPENT";
	public locationSection: LocationSectionEnum;
	public newLocationTimeSpentInSeconds: number;

	public constructor(locationSection: LocationSectionEnum, timeSpentInSeconds: number) {
		super(AddLocationTimeSpentDataLayerModel.EVENT_NAME);
		this.locationSection = locationSection;
		this.newLocationTimeSpentInSeconds = timeSpentInSeconds;
	}
}